// extracted by mini-css-extract-plugin
export var highlightFade = "_28-4";
export var highlighted = "_28-3";
export var table = "_28-1";
export var tableContainer = "_28-0";
export var totalsRow = "_28-2";